import { get } from "lodash";
import { useContext, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { StoreContext } from "shared/store";
import graphql from "utils/api/graphql";
import { resolveSubscriptionTemplate } from "./resolveSubscriptionTemplate";

export const STEPPER_KEYS = {
  ADDITIONAL_INFORMATION: "ADDITIONAL_INFORMATION",
  PROOF: "PROOF",
  DOCUMENT: "DOCUMENT",
};
const Detail = (_) => {
  const { id } = useParams();
  const { user } = useContext(StoreContext);
  const [organization, setOrganization] = useState(get(user, "organization"));

  const { data: subscriptionData } = useQuery(graphql.queries.SUBSCRIPTION, {
    variables: { where: { id } },
    skip: !id,
  });

  useQuery(graphql.queries.ORGANIZATION, {
    skip: !get(user, "organization.id"),
    variables: {
      where: { id: get(user, "organization.id") },
      exclude: [
        "networkPlan",
        "networkInsurancePlan",
        "users",
        "telecoms",
        "networkCoverage",
        "attachments",
        "broker",
        "counterpartyContracts",
      ],
    },
    onCompleted: ({ organization }) => {
      setOrganization(organization);
    },
  });
  const processTemplate = get(
    subscriptionData,
    "subscription.project.fields.processTemplate",
  );
  const SubscriptionTemplate = useMemo(
    () =>
      resolveSubscriptionTemplate({
        processTemplate,
        organizationTemplate: get(organization, "config.template"),
      }),
    [organization, processTemplate],
  );

  if (!organization || !SubscriptionTemplate) return <Loading />;
  return <SubscriptionTemplate config={get(organization, "config")} />;
};

export default Detail;
